import { Box, Typography } from "@outschool/backpack";
import { ActivityListing_ListingFragment } from "@outschool/gql-frontend-generated";
import React from "react";

import { useMembershipRequirement } from "../subscriptions/hooks/useMembershipRequirement";
import { MobileListing } from "./MobileListing";

type MobileActivityListComponentProps = {
  lists: ActivityListing_ListingFragment[];
  title: string;
  searchUid?: string;
  backgroundColor?: string;
};
export const MobileActivityListComponent = ({
  lists,
  title,
  searchUid,
  backgroundColor,
}: MobileActivityListComponentProps) => {
  const { showCredits } = useMembershipRequirement();

  return (
    <Box
      sx={{
        padding: ".8rem 1.6rem 4rem",
        backgroundColor,
      }}
    >
      <Typography emphasized variant={"h6"} marginTop={32}>
        {title}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: ".8rem",
          marginTop: "1.6rem",
        }}
      >
        {lists.map((list, index) => (
          <MobileListing
            key={list.activity.uid}
            activity={list.activity}
            nextSection={list.nextSection}
            leader={list.leader}
            trackingProperties={{
              order: index + 1,
              activity_title: list.activity.title,
              searchUid,
            }}
            insertionId={list.insertionId}
            disabled={false}
            listingIndex={index}
            showCredits={showCredits}
          />
        ))}
      </Box>
    </Box>
  );
};
